import React, { useState } from 'react';
import { IonCard, IonItem, isPlatform, IonIcon, IonButton } from '@ionic/react';
import { useAuthService } from '../../services/Auth';
import './Logout.scss';
import { clear, GPSWrapper, IONICWrapper } from '../../utils/common';
import { LogoutPopUp } from '../../components/app/LogoutPopup/LogoutPopup';
import { useTranslation } from 'react-i18next';
import { logEvent, setScreenName } from '../../utils/Analytics';
import { EVENT, SCREEN } from '../../utils/constants.analytics';
import { usePushNotification } from 'app/utils/usePushNotification';
import { UpdateStopModel } from "app/models/home/updateStop.model";
import { DB_GPS_ACTIVATED_SHIPMENT, EGPSTrackingStatus } from "app/utils/constants";

const { unRegisterPush } = usePushNotification();

const LogOutPage: React.FC<any> = (props) => {
  const authService = useAuthService();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  async function azureLogout() {
    // Analytics implementation On logging out of Registration Page
    logEvent(props.isRegistrationPage ? EVENT.UE_REGISTRATION_LOGOUT : EVENT.UE_LOGOUT,
      {
        screen: props.isRegistrationPage ? SCREEN.REGISTRATION_LEAKAGE : SCREEN.MR_LOGOUT,
      });

    if (isPlatform("capacitor")) {
      const _model: UpdateStopModel = new UpdateStopModel();
      const gpsActivatedShipmentID = await getGPSActivatedShipmentID();
      gpsActivatedShipmentID && props.updateGPSInfo(
        _model.updateGPS({
          shipmentId: gpsActivatedShipmentID,
          gpsTrackingStatus: EGPSTrackingStatus.GPS_TRACKING_STOPPED
        }), () => {});
      GPSWrapper.details.stopGPS();
      unRegisterPush();
    }
    setShowLogoutModal(false);
    await clear();
    await authService.logout();
    await props.logout();
  }

  async function getGPSActivatedShipmentID() {
    const _shipment = IONICWrapper.details.vault && (await IONICWrapper.details.vault.getValue(DB_GPS_ACTIVATED_SHIPMENT));
    const gpsActivatedShipmentID = _shipment && JSON.parse(_shipment).shipmentID;
    return gpsActivatedShipmentID;
  }

  const showLgoutPopUp = () => {
    //Cannot log out without data connection. Alert message will be shown to check network connectivity.
    if (!props.isNetworkAvailable) {
      props.showAlert();
    } else {
      setShowLogoutModal(true);
    }
  };
  const { t } = useTranslation();
  setScreenName("screen_logout_page");
  return (
    <>
      {props.isRegistrationPage ? (
        isPlatform("mobile") ? (
          <IonIcon
            className="page-close"
            icon="close"
            data-testid="log-out"
            onClick={() => showLgoutPopUp()}
          />
        ) : (
          <IonButton
            expand="full"
            className="cancel-button"
            data-testid="log-out"
            onClick={() => showLgoutPopUp()}
          >
            {t('Cancel')}
          </IonButton>
        )
      ) : (
        <IonCard onClick={() => showLgoutPopUp()} data-testid="log-out" class="menu_list_card_logout">
          <IonItem lines="none" class="Logout_item">
          {t('Log Out')}
            <img
              slot="end"
              alt="logo"
              src="/assets/icon/Logout-Icon.svg"
              className="logoutImg"
            />
          </IonItem>
        </IonCard>
      )}
      <LogoutPopUp
        showLogoutModal={showLogoutModal}
        closeShowModal={() => {
          setShowLogoutModal(false);
        }}
        logOut={async () => azureLogout()}
        isRegistrationPage={props.isRegistrationPage}
      />
    </>
  );
};
export default LogOutPage;
